// import api from 'api';
import api from "./../api";

import Swal from "sweetalert2";
import UtilsUrl from "../../utils/UtilsUrl";

const saveContratDePartege = async (formData) => {
  return api.post(
    UtilsUrl.rhURL() + "/contract_partage/saveContratDePartage",
    formData
  );
};
const getAll = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/contract_partage/" + idUser);
};
const getById = async (idContrat) => {
  return api.get(UtilsUrl.rhURL() + `/contract_partage/getById/${idContrat}`);
};
const deleteContrat = async (contratid, setContract) => {
  try {
    const result = await Swal.fire({
      title: "Es-tu sûr?",
      text: "Vous ne pourrez pas annuler cette action !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimez-le !",
      cancelButtonText: "Non, annulez !",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      await api.put(
        UtilsUrl.rhURL() + `/contract_partage/archive/${contratid}`,
        { isDeleted: true }
      );

      Swal.fire("Supprimé !", "Employee supprimé avec succès.", "success");

      setContract((prevState) =>
        prevState.filter((contrat) => contrat.idContratP !== contratid)
      );
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your file is safe :)", "error");
    }
  } catch (error) {
    console.error(error);
  }
};
const updateContract = async (id, contract) => {
  return await api.put(
    UtilsUrl.rhURL() + `/contract_partage/update/${id}`,
    contract
  );
};
export { saveContratDePartege, getAll, getById, deleteContrat, updateContract };
